import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAddEveryoneToResourceGroup,
  useAddResourceToResourceGroup,
  useRemoveResourceFromResourceGroup,
} from "@planzone/view-models";
import { Identifiable, ProjectResource, Resource } from "@planzone/dto";
import { ResourceSelect } from "../resourceSelect";
import { ProjectResourceSelect } from "../projectResourceSelect";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceForm({ group, project, resources }: Props) {
  const { t } = useTranslation();
  const { addResourceToResourceGroup } = useAddResourceToResourceGroup(group, {
    uuid: "",
  });
  const { removeResourceFromResourceGroup } =
    useRemoveResourceFromResourceGroup(group, { uuid: "" });
  const { addEveryoneToResourceGroup, isRequestPending } =
    useAddEveryoneToResourceGroup(group);

  return (
    <div className={styles.resourceForm}>
      {group.resourceType === "project" ? (
        <ProjectResourceSelect
          project={project}
          projectResources={resources as Identifiable<ProjectResource>[]}
          addResources={(resources) =>
            resources.forEach((resource) =>
              addResourceToResourceGroup({ group, resource }),
            )
          }
          removeResources={(resources) =>
            resources.forEach((resource) =>
              removeResourceFromResourceGroup({ group, resource }),
            )
          }
          addEveryone={() => addEveryoneToResourceGroup({ group, project })}
          isEveryonePending={isRequestPending}
        />
      ) : (
        <ResourceSelect
          resources={resources as Identifiable<Resource>[]}
          addResources={(resources) =>
            resources.forEach((resource) =>
              addResourceToResourceGroup({ group, resource }),
            )
          }
          removeResources={(resources) =>
            resources.forEach((resource) =>
              removeResourceFromResourceGroup({ group, resource }),
            )
          }
          addEveryone={() => addEveryoneToResourceGroup({ group })}
          isEveryonePending={isRequestPending}
        />
      )}
    </div>
  );
}

export { ResourceForm };
